import * as React from "react";
import setRef from "../setRef/setRef.js";
function useForkRef(...refs) {
  return React.useMemo(() => refs.every((ref) => ref == null) ? null : (instance) => {
    refs.forEach((ref) => {
      setRef(ref, instance);
    });
  }, refs);
}
export {
  useForkRef as default
};
//# sourceMappingURL=useForkRef.js.map
